import { MagicConfigMixin, formatCurrency } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { BALANCE_UPDATED, BALANCE_CURRENCY_UPDATED } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DepositWidgetComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.balance = null;
    this.currency = null;
    this.balanceSubscription = null;
    this.currencySubscription = null;
  }
  created() {
    this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, (event) => {
      var _a;
      this.balance = (_a = event.payload) != null ? _a : null;
    }, { replay: true });
    this.currencySubscription = window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, (event) => {
      this.currency = event.payload;
    }, { replay: true });
  }
  destroyed() {
    if (this.balanceSubscription) {
      this.balanceSubscription.unsubscribe();
    }
    if (this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }
  }
};
DepositWidgetComponent = __decorateClass([
  Component({
    name: "deposit-widget",
    filters: {
      formatCurrency
    }
  })
], DepositWidgetComponent);

export default DepositWidgetComponent;
